export default "__VITE_ASSET__KzY4Cd2s__"